import { Action, AnyAction, combineReducers, configureStore, Reducer, ThunkAction } from '@reduxjs/toolkit';
import {
  sportsbookReducer,
  categoryReducer,
  bonusesReducer,
  gamesReducer,
  searchReducer,
  financialOperationReducer,
  accountReducer,
  authReducer,
  globalReducer,
  overlayReducer,
  promotionsReducer,
  errorReducer,
  refillReducer,
  withdrawReducer,
  verifyReducer,
  authReducerInitialState,
  accountReducerInitialState,
  overlayReducerInitialState,
  financialOperationReducerInitialState,
  withdrawReducerInitialState,
  refillReducerInitialState,
  paynplayReducer,
  sportsbookReducerInitialState,
  strapiReducer,
  wheelReducerInitialState,
  wheelReducer,
  socketReducer,
} from '@spinwise/spinwise-core';

import { persistStore, persistReducer, FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER } from 'redux-persist';

import storage from 'redux-persist/lib/storage';
import { PATHS } from 'Libraries/routes.library';
import { setCookie } from 'cookies-next';

// Do not persist overlays and account data (debatable)
const persistConfig = {
  key: 'persistent-store-state',
  storage,
  blacklist: [
    'globalReducer',
    'errorReducer',
    'bonusesReducer',
    'refillReducer',
    'withdrawReducer',
    'categoryReducer',
    'gamesReducer',
    'sportsbookReducer',
    'strapiReducer',
  ],
};

const rootReducer: Reducer = (state: any, action: AnyAction) => {
  switch (action.type) {
    case 'LOG_OUT':
      //storage.removeItem('persist:root')
      // clear state works basically as log out
      state = {
        ...state,
        globalReducer: {
          ...state.globalReducer,
          loading: action.data,
        },
        authReducer: {
          ...authReducerInitialState,
          loading: false,
        },
        accountReducer: accountReducerInitialState,
        overlayReducer: overlayReducerInitialState,
        withdrawReducer: withdrawReducerInitialState,
        refillReducer: refillReducerInitialState,
        financialOperationReducer: financialOperationReducerInitialState,
        sportsbookReducer: sportsbookReducerInitialState,
        wheelReducer: wheelReducerInitialState,
      };

      // clear session timer
      localStorage.removeItem('sessionTime');

      // redirect to home
      break;

    case 'LOG_OUT_SUCCESS':
      // once finished, redirects
      if (window.location.pathname !== PATHS.HOME) {
        // window.location.href = PATHS.HOME;
      }
      break;
    case 'CLEAR_CACHE':
      state = {
        ...state,
        globalReducer: {
          ...state.globalReducer,
          loading: action.data,
        },
        authReducer: {
          ...authReducerInitialState,
          loading: false,
        },
        accountReducer: accountReducerInitialState,
        overlayReducer: {
          ...overlayReducerInitialState,
          paynplayRegister: state.overlayReducer.paynplayRegister,
        },
        withdrawReducer: withdrawReducerInitialState,
        refillReducer: refillReducerInitialState,
        financialOperationReducer: financialOperationReducerInitialState,
        wheelReducer: wheelReducerInitialState,
      } as any;

      break;
    case 'BOOTSTRAP_APPLICATION':
      state = {
        ...state,
        overlayReducer: {
          ...overlayReducerInitialState,
          paynplayRegister: {
            ...state.overlayReducer.paynplayRegister,
            amount: state.overlayReducer.paynplayRegister?.defaultAmount,
            show: false,
          },
        },
        accountReducer: {
          ...state.accountReducer,
          vip: accountReducerInitialState.vip,
        },
      };
      break;

    case 'BOOTSTRAP_LOADING':
      state = {
        ...state,
        globalReducer: {
          ...state.globalReducer,
          loading: action.data,
        },
      };
      break;
    case 'OVERLAY_LOGIN_SHOW':
      state = {
        ...state,
        authReducer: {
          ...state.authReducer,
          error: null,
          loading: false,
        },
      };
      break;
    case 'AUTH_LOGIN_PNP_SUCCESS':
    case 'LOG_IN_SUCCESS':
      setCookie('cookieConsent', 'true', {});
      break;
  }

  return appReducer(state, action);
};

const appReducer = combineReducers({
  categoryReducer,
  bonusesReducer,
  gamesReducer,
  searchReducer,
  accountReducer,
  globalReducer,
  overlayReducer,
  promotionsReducer,
  authReducer,
  errorReducer,
  refillReducer,
  financialOperationReducer,
  withdrawReducer,
  verifyReducer,
  sportsbookReducer,
  paynplayReducer,
  strapiReducer,
  wheelReducer,
  socketReducer,
});

const persistentRootReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
  reducer: persistentRootReducer,
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});

const persistentStore = persistStore(store);

export { persistentStore, store };

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<ReturnType, RootState, unknown, Action<string>>;
